import styled from 'styled-components';

import chevronRightBlack from '../../../images/common/chevron-right-black.svg';

export const UseCasesStyled = styled.div`
  position: relative;
  padding-bottom: 60px;
  background: var(--lgray);
  @media (min-width: 992px) {
    padding-bottom: 220px;
  }
`;

export const UseCasesDiagonalGrayTop = styled.div`
  background: var(--white);
  width: 100%;
  padding: 50px 0;
  clip-path: polygon(0 35%, 100% 0, 100% 0, 0 0);
  @media (min-width: 1024px) {
    padding-top: 75px;
  }
  @media (min-width: 1200px) {
    padding-top: 176px;
    clip-path: polygon(0 90%, 100% 0, 100% 0, 0 0);
  }
`;

export const Title = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  text-align: center;
  &.hide {
    visibility: hidden;
  }
`;

export const CardsContainer = styled.div`
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 1200px) {
    margin-top: 113px;
    display: flex;
    & .animate__animated:not(:last-of-type) {
      margin-right: 24px;
    }
  }
`;

export const PaginationPill = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-pill);
  height: 56px;
  width: 149px;
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  padding: 4px;
  border-radius: 32px;
  margin-left: 20px;
`;

export const SliderContainer = styled.div`
  margin-bottom: 80px;
  .slick-slider {
    .slick-list {
      .slick-track {
        padding: 0px 20px;
        .slick-slide {
          padding: 40px 0;
          margin: -3px 0;
          &:not(:last-of-type) {
            > div {
              margin-right: 24px;
            }
          }
        }
      }
    }
    .slick-arrow {
      top: unset;
      bottom: -40px;
      transform: unset;
      cursor: pointer;
      &.slick-prev {
        left: 8%;
        transform: rotate(180deg);
        &::before {
          background-image: url('${chevronRightBlack}');
          background-size: 20px 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
          content: '';
        }
        @media (min-width: 768px) {
          left: 5%;
        }
      }
      &.slick-next {
        right: unset;
        left: 38%;
        &::before {
          background-image: url('${chevronRightBlack}');
          background-size: 20px 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
          content: '';
        }
        @media (min-width: 393px) {
          left: 35%;
        }
        @media (min-width: 410px) {
          left: 34%;
        }
        @media (min-width: 414px) {
          left: 33%;
        }
        @media (min-width: 480px) {
          left: 28%;
        }
        @media (min-width: 768px) {
          left: 16%;
        }
        @media (min-width: 1024px) {
          left: 12%;
        }
      }
    }
  }
  @media (min-width: 1200px) {
    display: none;
  }
`;

export const Btn = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 40px;
  width: 138px;
  border-radius: 32px;
  background-color: var(--pink);
  border: 1px solid var(--pink);
  color: var(--white);
  font-family: Rubik;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  &:hover {
    color: var(--pink);
    background: var(--white);
  }
`;

export const Card = styled.div`
  box-sizing: border-box;
  height: 304px;
  width: 264px;
  border-radius: 20px;
  background-color: var(--white);
  box-shadow: 0 0 50px 0 rgba(4, 30, 66, 0.1);
  padding: 32px;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  z-index: 0;
  outline: none;
  @media (min-width: 992px) {
    &:hover {
      box-shadow: 0 0 50px 0 rgba(4, 30, 66, 0.2);
      transform: scale(1.1);
      z-index: 1;
    }
  }
`;

export const CardIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const CardTitle = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  width: 200px;
  min-height: 152px;
`;
